var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.6821 6.4444H5.6821H21.6821",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6821 6.4444V20.4444C19.6821 20.9748 19.4714 21.4835 19.0963 21.8586C18.7212 22.2337 18.2125 22.4444 17.6821 22.4444H7.6821C7.15167 22.4444 6.64296 22.2337 6.26789 21.8586C5.89282 21.4835 5.6821 20.9748 5.6821 20.4444V6.4444M8.6821 6.4444V4.4444C8.6821 3.91396 8.89282 3.40526 9.26789 3.03018C9.64296 2.65511 10.1517 2.4444 10.6821 2.4444H14.6821C15.2125 2.4444 15.7212 2.65511 16.0963 3.03018C16.4714 3.40526 16.6821 3.91396 16.6821 4.4444V6.4444",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6821 11.4444V17.4444",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6821 11.4444V17.4444",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.c65dab8d9f933a43d248cb9a21ef3297.svg";
export { ForwardRef as ReactComponent };